import isEmpty from 'lodash/isEmpty';

import PIPELINE_STATUSES from './PIPELINE_STATUSES';
import isEqualPipelineIntegrations from './isEqualPipelineIntegrations';

export default function getPipelineStatus({ pipeline, deployedPipeline, deployedRevisions }) {
  if (!pipeline) {
    return PIPELINE_STATUSES.NotDeployed;
  }

  if (isEmpty(pipeline.pipelineIntegrations) && !deployedPipeline) {
    return PIPELINE_STATUSES.NotDeployed;
  }

  // Only determine equality for Ion staged Pipeline Integrations
  // CLI managed integrations don't impact determining whether or not the Pipeline is fully deployed
  const deployedIonRevisions = deployedRevisions.filter(deployedRevision => !deployedRevision.cliManaged);

  const isFullyDeployed = isEqualPipelineIntegrations({
    deployedRevisions: deployedIonRevisions,
    pipelineIntegrations: pipeline.pipelineIntegrations,
  });

  if (isFullyDeployed) {
    return PIPELINE_STATUSES.Deployed;
  }

  return PIPELINE_STATUSES.StagedForDeploy;
}
